import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IPatientVitals } from '../../../features/vitals/store/vitals.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addWithdrawalScale = (pcr: any): IPcr => {
  try {
    if (
      pcr.patient &&
      pcr.patient.patientVitals?.length &&
      pcr.patient.patientVitals[0].withdrawalScaleCriteria === undefined
    ) {
      pcr.patient.patientVitals.forEach((vital: IPatientVitals) => {
        setValueForPathWithCreate(vital, 'withdrawalScaleCriteria', [])
        setValueForPathWithCreate(vital, 'withdrawalScaleType', null)
        setValueForPathWithCreate(vital, 'withdrawalScaleTotal', null)
        setValueForPathWithCreate(vital, 'withdrawalScaleTotalPNNV', null)
        setValueForPathWithCreate(vital, '__isWithdrawalScaleTotalPNNVEnabled', false)
        setValueForPathWithCreate(vital, '__isWithdrawalScaleTypeCleared', false)
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addWithdrawalScale: ${error}`)
    throw error
  }
}
